module.exports = __webpack_public_path__ + "img/text-con-7.1f7a0134.png";